<template>
  <div id="page-recommend-in">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="6em"
    >
      <el-row>
        <el-form-item prop="regionId" label="Region">
          <filter-businessline-region :value.sync="searchForm.regionId" businessLine="2" />
        </el-form-item>
        <el-form-item label="时间" required>
          <el-date-picker
            v-model="searchForm.date"
            value-format="yyyy-MM-dd"
            type="date"
            :clearable="false"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="fetchData(true)" :loading="isLoading">查询</el-button>
          <el-button
            @click="exportSearchData"
            :loading="exportLoading"
            :disabled="dataList.length === 0"
            >导出</el-button
          >
        </el-form-item>
      </el-row>
    </el-form>
    <!-- 列表 -->
    <el-table stripe :data="dataList" v-loading="isLoading">
      <el-table-column
        v-for="(item, index) in commendTableList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      />
    </el-table>
    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        background
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'
import blobToFile from '@bike/blob-to-file'
import { commendTable } from './table'
import lxUtils from '@/mixins/lx'

export default {
  mixins: [pagination, lxUtils],

  data() {
    return {
      cid: 'c_mobikeops_ebikeBusiness_data_Pointinrecommendation_sacan',
      isLoading: false,
      exportLoading: false,
      dataList: [],
      dateRange: [],
      commendTableList: commendTable,
      cacheParams: {},
      searchForm: {
        regionId: '',
        date: '',
      },
    }
  },

  created() {
    this.initPagination('fetchData', false)
  },

  mounted() {
    this.searchForm.date = this.timeDefault
  },

  computed: {
    timeDefault() {
      const before = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
      const s1 = this.associateUtils && this.associateUtils.dateFormat(before)
      return s1
    },
  },

  methods: {
    // 列表
    fetchData(init = false) {
      if (init) this.pageNo = 1
      const params = {
        ...this.searchForm,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      }
      this.cacheParams = {
        regionId: this.searchForm.regionId,
        date: this.searchForm.date,
      }
      this.isLoading = true
      this.fetch
        .get('getRecommendInData', { params })
        .then(res => {
          const { list = [], total = 0 } = res.data || {}
          this.isLoading = false
          this.dataList = list
          this.totalAmount = total
        })
        .catch(() => {
          this.dataList = []
          this.isLoading = false
        })
    },

    // 导出
    exportSearchData() {
      const params = {
        ...this.cacheParams,
      }
      this.exportLoading = true
      this.fetch
        .get('exportRecommendInData', {
          responseType: 'blob',
          params,
        })
        .then(res => {
          blobToFile(res, { fileName: '调入点位推荐', ext: 'xlsx' })
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
  },
}
</script>
